import React, { useEffect, useState } from "react";
import {
  Modal,
  Tooltip,
  IconButton ,
  Typography,
  Card,
  Grid,
  Dialog,
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  Hidden,
  Paper,
  CardContent,
  Select,
  InputLabel,
  MenuItem,
  TextField,
  CircularProgress,
  Alert, 
  AlertTitle,
} from "@mui/material";
import { Theme, useTheme } from '@mui/material/styles'
import { createStyles, makeStyles } from '@mui/styles';
import { useLocalStorage } from "../../utils/LocalStorageHook";
import { GetEquipmentCapacity } from "../../utils/GetAdmin";
import { saveEquipmentCapacity } from "../../utils/PostAdmin";
import requestMissingContexts, {determineConfigLong,determineConfig,displayConfig} from "../../utils/GetContext";
import TableAbstraction from "../../componentUtils/TableAbstraction";
import {checkForRole} from "../../utils/GetAuth";
import LockIcon from '@mui/icons-material/Lock';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import Clear from "@mui/icons-material/Clear";


function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
      top: `${top}%`,
      left: `${left}%`,
      transform: `translate(-${top}%, -${left}%)`,
  };
}


const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    centerDiv: {
      textAlign: "center",
    },
    root: {},
    divWidth: {
      width: "100%",
    },
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    modalGrid: {
      marginTop: theme.spacing(2),
    },
    modalTitle:{
      color: theme.palette.primary.main,
    },
    modalCard: {
    },
    modalText: {
    },
    modalInput: {
      width:"350px"
    },
    paper: {
        position: 'absolute',
        backgroundColor: theme.palette.background.paper,
        border: `1px solid`,
        borderColor: theme.palette.border.main, 
        boxShadow: theme.shadows[4],
        padding: theme.spacing(2, 2, 2),
    },
  })
);
export default function AdminEquipmentCapacity() {
  const classes = useStyles();
  const [equipmentCapacity, SetEquipmentCapacity] = useState<any[]>([]);
  const [codes, setCodes] = React.useState<any>();
  const [salesOrg,] = useLocalStorage("SETTINGS.salesOrg", "");
  const [doneLoading, setDoneLoading] = React.useState<boolean>();
  const [muiTable, setMuiTable] = React.useState<any>({rpp:25});
  const [confirmDelete, setConfirmDelete] = React.useState<boolean>(false);
  const [clientId,] = useLocalStorage("SETTINGS.clientId", 100);
  const enabled = checkForRole(`${clientId}`,salesOrg,'vp_admin');
  const [useCompact] = useLocalStorage("SETTINGS.compact", true);

  const handleDelete = () => {
    setConfirmDelete(true);
    let oldCapacity = {model: editedRowModel, packType:editedRowPacktype, packSize:editedRowPacksize,columnSingleCapacity:editedRowSinglecapacity,nvcSingle:editedRowNvccapacity,columnDoubleCapacity:editedRowDoublecapacity,nvcDouble:editedRowNvcDoublecapacity,machinecategory:'BTL',columnWidth:'',guid:editedRowguid};
    saveEquipmentCapacity(salesOrg,oldCapacity,undefined).then((ret:any) => {
      if(ret && ret.data){
        //console.log(ret.data.mdEquipmentModelCapacities)
        SetEquipmentCapacity(ret.data.mdEquipmentModelCapacities)
        if(ret.data.message){
          alert(ret.data.message);
        }
      }
    });
    setEditedRow(undefined);
  }
  const setCurrent = (tableRow:any) => {
    setEditedRow(tableRow);
    seteditedRowModel(tableRow.model);
    seteditedRowPacktype(tableRow.packType);
    seteditedRowPacksize(tableRow.packSize);
    seteditedRowSinglecapacity(tableRow.columnSingleCapacity);
    seteditedRowDoublecapacity(tableRow.columnDoubleCapacity);
    seteditedRowNvccapacity(tableRow.nvcSingle);
    seteditedRowNvcDoublecapacity(tableRow.nvcDouble);
    seteditedRowguid(tableRow.guid);
  }

  const handleEdit = (tableRow:any) => {
    setCurrent(tableRow);
    setOpenEditWindow(true);
  }

  const [editedRow, setEditedRow] = React.useState<any|undefined>(undefined);
  const [editedRowSinglecapacity, seteditedRowSinglecapacity] = React.useState<string>("");
  const [editedRowNvccapacity, seteditedRowNvccapacity] = React.useState<string>("");
  const [editedRowDoublecapacity, seteditedRowDoublecapacity] = React.useState<string>("");
  const [editedRowModel, seteditedRowModel] = React.useState<string>("");
  const [editedRowPacktype, seteditedRowPacktype] = React.useState<string>("");
  const [editedRowPacksize, seteditedRowPacksize] = React.useState<string>("");
  const [editedRowguid, seteditedRowguid] = React.useState<string>("");
  
  const [editedRowNvcDoublecapacity, seteditedRowNvcDoublecapacity] = React.useState<string>("");
  const [modalStyle] = React.useState(getModalStyle);
  const [openEditWindow, setOpenEditWindow] = React.useState(false);
  const handleModalClose = () => {
    setOpenEditWindow(false);
    setEditedRow(undefined);
    seteditedRowModel("");
    seteditedRowPacktype("");
    seteditedRowPacksize("");
    seteditedRowSinglecapacity("");
    seteditedRowDoublecapacity("");
    seteditedRowNvccapacity("");
    seteditedRowNvcDoublecapacity("");
    seteditedRowguid("");
  }
  const handleModalSave = () => {
 
    let oldCapacity = (editedRow) ? {
      model: editedRow.model,
      packType:editedRow.packType, 
      packSize:editedRow.packSize,
      columnSingleCapacity:editedRow.columnSingleCapacity,
      nvcSingle:editedRow.nvcSingle,
      columnDoubleCapacity:editedRow.columnDoubleCapacity,
      nvcDouble:editedRow.nvcDouble,
      machinecategory:'BTL',
      columnWidth:'',
      guid:editedRow.guid,
    } : undefined;

    let newCapacity = {model: editedRowModel, packType:editedRowPacktype, packSize:editedRowPacksize,columnSingleCapacity:editedRowSinglecapacity,nvcSingle:editedRowNvccapacity,columnDoubleCapacity:editedRowDoublecapacity,nvcDouble:editedRowNvcDoublecapacity,machinecategory:'BTL',columnWidth:'',guid:editedRowguid};
    saveEquipmentCapacity(salesOrg,oldCapacity,newCapacity).then((ret:any) => {
      if(ret && ret.data){
        SetEquipmentCapacity(ret.data.mdEquipmentModelCapacities)
        if(ret.data.message){
          alert(ret.data.message);
        }
      }
    });
    setOpenEditWindow(false);
    setEditedRow(undefined);
  } 


  useEffect(() => {
    if (doneLoading) return;
    requestMissingContexts(["vp_email_dl",
      "PACKTYPE",
      "PACKSIZE",
      "SALESOFFICES",
    ])
      .then((v) => {

        setCodes(v);
      })
      .then((_) => {
        GetEquipmentCapacity(salesOrg).then((v) => {
          setDoneLoading(true);
          if(v && v.mdEquipmentModelCapacities) SetEquipmentCapacity(v.mdEquipmentModelCapacities);
        });
      });
  }, [equipmentCapacity, muiTable, confirmDelete, doneLoading, salesOrg]);


  const modalBody = (
    <div style={modalStyle} className={classes.paper} >
    <Typography variant="h4" className={classes.modalTitle} paragraph>Equipment Capacity
  </Typography>
    <Grid container spacing={2} className={classes.modalGrid}>
      <Grid item xs={12}>
        <Card className={classes.modalCard}>
          <CardContent>
          <Grid container spacing={1} className={classes.modalGrid}>
          <Grid item xs={'auto'} md={'auto'} xl={'auto'}>
          <InputLabel >Model</InputLabel>
            <TextField placeholder='Model' type='text'
                className={classes.modalInput}
                value={editedRowModel}
                onChange={(e) => { 
                  seteditedRowModel((e.target.value &&  typeof e.target.value == 'string') ? e.target.value : "") 
                }}></TextField>
          </Grid>
          </Grid>
          <Grid container spacing={1} className={classes.modalGrid}>
          <Grid item xs={'auto'} md={'auto'} xl={'auto'}>
            <InputLabel >Pack Type</InputLabel>
            <Select label="Pack Type" placeholder='Pack Type' value={editedRowPacktype}
                inputProps={{name: 'Pack Type',}}
                className={classes.modalInput}
                onChange={(e) => { 
                    seteditedRowPacktype((e.target.value &&  typeof e.target.value == 'string') ? e.target.value : ""); 
                    }}>
                  <MenuItem key='*' value='*'>{"All"}</MenuItem>
                  {displayConfig(codes, "PACKTYPE")?.map((dl: any, i: number) => (
                      <MenuItem key={dl.code} value={dl.code}>
                        {dl.text} - {dl.textLong}
                      </MenuItem>
                    ))}
            </Select>
          </Grid>
          </Grid>
          <Grid container spacing={1} className={classes.modalGrid}>
            <Grid item xs={'auto'} md={'auto'} xl={'auto'}>
            <InputLabel >Pack Size</InputLabel>
            <Select label="Pack Size" placeholder='Pack Size' value={editedRowPacksize}
                inputProps={{name: 'Pack Size',}}
                className={classes.modalInput}
                onChange={(e) => { 
                    seteditedRowPacksize((e.target.value &&  typeof e.target.value == 'string') ? e.target.value : ""); 
                    }}>
                  <MenuItem key='*' value='*'>{"All"}</MenuItem>
                  {displayConfig(codes, "PACKSIZE")?.map((dl: any, i: number) => (
                      <MenuItem key={dl.code} value={dl.code}>
                        {dl.text}
                      </MenuItem>
                    ))}
            </Select>
            </Grid>
            </Grid>
            <Grid container spacing={1} className={classes.modalGrid}>
            <Grid item xs={'auto'} md={'auto'} xl={'auto'}>
              <InputLabel >Single Capacity</InputLabel>
              <TextField placeholder='Single Capacity' type='number'
                className={classes.modalInput}
                value={editedRowSinglecapacity}
                onChange={(e) => { 
                  seteditedRowSinglecapacity((e.target.value &&  typeof e.target.value == 'string') ? e.target.value :"0") 
                }}></TextField>

              </Grid>
           <Grid item xs={'auto'} md={'auto'} xl={'auto'}>
              <InputLabel >NVC Single</InputLabel>
                <TextField placeholder='NVC Single' type='number'
                    className={classes.modalInput}
                    value={editedRowNvccapacity}
                    onChange={(e) => { 
                      seteditedRowNvccapacity((e.target.value &&  typeof e.target.value == 'string') ? e.target.value : "0") 
                    }}></TextField>
              </Grid>
            <Grid item xs={'auto'} md={'auto'} xl={'auto'}>
              <InputLabel >Double Capacity</InputLabel>
                <TextField placeholder='Double Capacity' type='number'
                    className={classes.modalInput}
                    value={editedRowDoublecapacity}
                 onChange={(e) => { 
                  seteditedRowDoublecapacity((e.target.value &&  typeof e.target.value == 'string') ? e.target.value : "0") 
                }}></TextField>
              </Grid>
            <Grid item xs={'auto'} md={'auto'} xl={'auto'}>
            <InputLabel >NVC Double</InputLabel>
                  <TextField placeholder='NVC Double' type='number'
                      className={classes.modalInput}
                      value={editedRowNvcDoublecapacity}
                      onChange={(e) => { 
                        seteditedRowNvcDoublecapacity((e.target.value &&  typeof e.target.value == 'string') ? e.target.value : "0") 
                     }}></TextField>
            </Grid>
            </Grid>
            </CardContent>
          </Card>
          <div style={{ paddingRight: "5px", textAlign:"right"}}>
                <React.Fragment>
                    <Tooltip title={"Save"}>
                        <IconButton onClick={handleModalSave}>
                            <SaveIcon />
                        </IconButton>
                    </Tooltip>
                    <Tooltip title={"Cancel"}>
                        <IconButton onClick={handleModalClose}>
                            <Clear />
                        </IconButton>
                    </Tooltip>
                </React.Fragment>
              </div>
        </Grid>
      </Grid>
    </div>
  );


  return (
    <div className={classes.root}>
      {doneLoading && enabled ? (
        <TableAbstraction
        settingsKey="ADM_EC"
          options={{
            draggableColumns: {
              enabled: true,
            },
            rowsPerPageOptions: [25, 50, 100],
            serverSide: false,
            selectableRows: "none",
            rowsPerPage: muiTable.rpp,
            onChangeRowsPerPage: (numberOfRows) => {
              muiTable.rpp = numberOfRows;
              setMuiTable(muiTable);
            },
            customToolbar: () => {
              return (
                <Tooltip title={`Add Capacity`}>
                  <IconButton  onClick={() => {
                    handleModalClose();
                    setOpenEditWindow(true);
                    }}>
                    <AddIcon />
                  </IconButton>
                </Tooltip>
              );
            },
          }}
          title="Equipment Capacity"
          columns={[
            {
              label: "Model",
              name: "model",
              options: {
                searchable: true,
                filter: false,
              },
            },
            {
              label: "Pack Type",
              name: "packType",
              options: {
                
                customBodyRender: (value: any) => {
                  return (
                      `${determineConfig(codes, "PACKTYPE", value)} - ${determineConfigLong(codes, "PACKTYPE", value)}`
                  );
                },
              },
            },
            {
              label: "Pack Size",
              name: "packSize",
              options: {
                customBodyRender: (value: any) =>
                  `${determineConfig(codes, "PACKSIZE", value)}` || "",
              },
            },
            {
              label: "Single Capacity",
              name: "columnSingleCapacity",
              options: {
                searchable: false,
                filter: false,
              },
            },
            {
              label: "NVC Single",
              name: "nvcSingle",
              options: {
                searchable: false,
                filter: false,
              },
            },
            {
              label: "Double Capacity",
              name: "columnDoubleCapacity",
              options: {
                searchable: false,
                filter: false,
              },
            },
            {
              label: "NVC Double",
              name: "nvcDouble",
              options: {
                searchable: false,
                filter: false,
              },
            },
            {
              label: "guid",
              name: "guid",
              options: {
                searchable: false,
                filter: false,
                display: false,
              },
            },
            {
              label: " ",
              name: "remove",
              options: {
                filter: false,
                setCellProps: () => ({ align: 'right' }),
                renderCell: (params) => {
                  if(!!useCompact)
                    return (
                        <React.Fragment>
                          <Tooltip title={"Edit"}>
                            <EditIcon 
                              fontSize="small"  
                              onClick={() => {handleEdit(params.row)}}/>
                          </Tooltip>
                          <Tooltip title={"Delete"}>
                            <DeleteIcon
                              fontSize="small" 
                              onClick={() => {setCurrent(params.row); setConfirmDelete(true);}} 
                            />
                          </Tooltip>
                        </React.Fragment>
                      );
                    else
                      return (
                          <React.Fragment>
                            <Tooltip title={"Edit"}>
                              <IconButton onClick={() => {handleEdit(params.row)}}>
                                <EditIcon />
                              </IconButton>
                            </Tooltip>
                            <Tooltip title={"Delete"}>
                              <IconButton onClick={() => {setCurrent(params.row); setConfirmDelete(true);}}>
                                <DeleteIcon />
                              </IconButton>
                            </Tooltip>
                          </React.Fragment>
                        );
                },
              },
            },
          ]}
          data={equipmentCapacity}
        />
      ) : ( enabled ? (
        <div className={classes.centerDiv}>
          <CircularProgress color="primary" />
        </div>) : (
          <Alert severity="error">
            <AlertTitle><LockIcon/> Access Error</AlertTitle>   
            You do not currently have access to <strong>Admin</strong> activities for the <strong>{salesOrg}</strong> bottler. 
          </Alert>
        )
      )}
          <Modal
                open={openEditWindow}
                onClose={handleModalClose}
            >
                {modalBody}

            </Modal>
            <Dialog
            open={confirmDelete}
            onClose={()=>setConfirmDelete(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
              Are you sure you want to delete the capacity for "{determineConfig(codes, "PACKSIZE", editedRowPacksize)} {determineConfigLong(codes, "PACKTYPE", editedRowPacktype)}" on model "{editedRowModel}"?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={()=>{handleDelete(); setConfirmDelete(false);}} color="primary">
                Yes
              </Button>
              <Button onClick={()=>{setEditedRow(undefined); setConfirmDelete(false);}} color="primary" autoFocus>
                No
              </Button>
            </DialogActions>
      </Dialog>
    </div>
  );
}